// Google OAuth Configuration
// Web Client ID from Google Cloud Console → APIs & Services → Credentials
// Note: The client secret is NOT needed in the frontend and should never be committed.

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '923602955007-84chtvlffks0b780ltjk8j19dpu79i7p.apps.googleusercontent.com';

// Instructions to get your Client ID:
// 1. Go to https://console.cloud.google.com/
// 2. Select or create a project
// 3. Enable "Google Sign-In API" in APIs & Services > Library
// 4. Go to APIs & Services > Credentials
// 5. Click "Create Credentials" > "OAuth client ID"
// 6. Choose "Web application"
// 7. Add authorized JavaScript origins:
//    - http://localhost:3000 (for development)
//    - https://yourdomain.com (for production)
// 8. Copy the Client ID and paste it below or set REACT_APP_GOOGLE_CLIENT_ID environment variable
